module.exports = __webpack_public_path__ + "static/checklist_f-bb049165c1f97f047815c68e10202aed.gif";